<!-- START CRUD STANDARD -->
<p-confirmDialog [key]="'CRUDBasicDetailConfirmDialog_'+CRUDItemBezeichnungPluralCapitalized"
    [appendTo]="confirmDialogAppendTo()" [acceptLabel]="translate.instant('Ja',true)"
    [rejectLabel]="translate.instant('Nein',true)"></p-confirmDialog>
<!-- [style]="{'z-index': '9999'}" -->
<p-blockUI [blocked]="blockedDocument">
    <i class="fa fa-spinner fa-pulse fa-3x fa-fw" style="position:absolute;top:25%;left:50%"></i>
</p-blockUI>
<ng-container *ngTemplateOutlet="CRUDTemplatePluginTop"></ng-container>
<div class="ui-g ui-fluid">
    <div class="ui-g-12 ui-g-nopad">
        <div class="ui-g-12 ui-lg-12" style="padding-top:0">
            <form [formGroup]="CRUDForm" #form (ngSubmit)="validateAndSaveCRUDItem(true)" novalidate>
                <div #divCardToolbar class="card">
                    <!-- [ngClass]="CRUDTemplatePluginTop == null ? 'card-toolbar' : null" [class.card-toolbar-static-inactive]="(app.isOverlay() || app.isHorizontal() || app.staticMenuDesktopInactive === true || !app.isDesktop()) && !app.isSlim()"
          [class.card-toolbar-horizontal-active]="!app.isOverlay() && app.isHorizontal() && app.isDesktop()"
          [class.card-toolbar-slim-active]="app.isSlim()"-->
                    <!-- class="card card-toolbar" US 14470 Toolbar nur fixiert, wenn kein CRUDTemplatePluginTop drüber -->

                    <!--MODI ggü IMKE: Die Buttonleiste ist in einem Grid, weil in der Mitte: pageTitle -->
                    <div class="titlebar-button-grid">
                        <div>
                            <!--<button style="width: auto;" pButton type="submit" icon="ui-icon-save" [label]="translate.instant('Speichern',true)"></button>-->
                            <button style="width: auto;" pButton type="submit" [icon]="CRUDButtonSaveIcon"
                                [label]="translate.instant(CRUDButtonSaveLabel,true)"></button>&nbsp;
                            <button style="width: auto;" pButton type="button" class="p-button-success" [icon]="CRUDButtonSaveIcon"
                                [label]="translate.instant('Rückmelden',true)" (click)="rueckmeldenAndSave()"></button>
                        </div>
                        <div style="text-align: center;">
                            <span style="line-height: 35px; font-size: medium; font-weight: 500;">{{pageTitle}}</span>
                        </div>
                        <div>
                            <span class="floatRight">
                                <!--<button style="width: auto;" pButton type="button" icon="ui-icon-help" [label]="translate.instant('Hilfe',true)" (click)="showHelp()"></button>-->
                                <button style="width: auto; margin-left: 5px;" pButton type="button"
                                    icon="ui-icon-close" [label]="translate.instant('Abbrechen',true)"
                                    (click)="cancelCRUDEdit()"></button><!-- [routerLink]="['/'+CRUDItemRoutePlural]"-->
                            </span>
                        </div>
                    </div>

                </div>

                <div [ngClass]="CRUDTemplatePluginTop == null ? 'card-container' : null">
                    <!-- class="card-container" US 14470 Toolbar nur fixiert, wenn kein CRUDTemplatePluginTop drüber -->
                    <div class="card">
                        <div class="ui-g form-group" id="parentDiv">

                            <!--CHILD_CONTENT-->
                            <!--<ng-container *ngIf="true==true; then CRUDChildTemplate">das hier dazw. wird niemals angezeigt!</ng-container>-->
                            <ng-container *ngTemplateOutlet="CRUDChildTemplate"></ng-container>

                            <!--<div class="ui-g-12 ui-md-12">
                  <div class="ui-g-12 ui-md-6">
                    <button pButton type="button" icon="ui-icon-delete" class="ui-button-danger" [label]="translate.instant(this.CRUDItemKurzform+ ' löschen',true)"
                      (click)="deleteCRUDItem()"></button>
                  </div>
              </div>-->

                        </div>
                    </div>
                    <div class="card" style="display: none;"><!--MODI: kein Footer-->
                        <!--<app-footer-info *ngIf="CRUDHideModified == false" [data]="CRUDItem" [deleteButtonLabel]="CRUDDisableLoeschen ? null : translate.instant(this.CRUDItemKurzform+ ' löschen',true)" (delete)="deleteCRUDItem()"></app-footer-info>-->

                        <div *ngIf="CRUDHideModified == true" class="ui-g">
                            <div class="ui-g-12 ui-md-12">
                                <div class="ui-g-12 ui-md-6 ui-lg-3">
                                    <button pButton type="button" icon="ui-icon-delete" class="ui-button-danger"
                                        [label]="translate.instant('Löschen',true)" (click)="deleteCRUDItem()"></button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <!--</fieldset>-->
            </form>
        </div>
    </div>
</div>
<button *ngIf="debugMode == true" pButton (click)="debug(form)" icon="fa-bug" title="debug form"></button>
<!-- ENDE CRUD STANDARD -->

<ng-template #CRUDChildTemplate>
  <div class="detail-grid">
    <div [formGroup]="CRUDForm" class="ui-g-12 ui-md-6 inputTextForm">
        <span class="p-float-label">
            <input style="width:90%" type="text" pInputText formControlName="behaelterNummer">
            <label>{{'Behälter-Nummer'|translate:true}} *</label>
        </span>
    </div>
    <div class="ui-g-12 ui-md-6">
        <div class="errorMessage">
            {{displayMessage.behaelterNummer}}
        </div>
    </div>

    <div [formGroup]="CRUDForm" class="ui-g-12 ui-md-6 inputTextForm">
        <span class="p-float-label">
            <p-calendar [locale]="DE" view="month" dateFormat="dd.mm.yy" [showTime]="false" [stepMinute]="01" [showSeconds]="true"
                [defaultDate]="dateNow" [utc]="true" formControlName="baujahr" [style]="{'width' : '90%'}"><!--dateFormat="mm/yy"-->
            </p-calendar>
            <label>{{'Baujahr'|translate:true}} *</label>
        </span>
    </div>
    <div class="ui-g-12 ui-md-6">
        <div class="errorMessage">
            {{displayMessage.baujahr}}
        </div>
    </div>

    <div class="ui-g-12 ui-md-6 inputTextForm"><!--[formGroup]="CRUDForm" -->
        <span class="p-float-label">
            <!--<input style="width:90%" type="text" pInputText formControlName="hersteller">-->
            <p-dropdown [options]="herstellerOptions" [(ngModel)]="herstellertOptionSelected" optionLabel="summary"
                [style]="{'width': '90%', 'height': '36px'}" (onChange)="herstellerOptionChanged($event)"></p-dropdown>
            <label>{{'Hersteller'|translate:true}} *</label>
        </span>
    </div>
    <div class="ui-g-12 ui-md-6">
        <div class="errorMessage">
            {{displayMessage.hersteller}}
        </div>
    </div>

    <div [formGroup]="CRUDForm" class="ui-g-12 ui-md-6 inputTextForm">
        <span class="p-float-label">
            <input style="width:90%" type="text" pInputText formControlName="lagerungsart">
            <label>{{'Lagerungsart'|translate:true}} *</label>
        </span>
    </div>
    <div class="ui-g-12 ui-md-6">
        <div class="errorMessage">
            {{displayMessage.lagerungsart}}
        </div>
    </div>


    <div [formGroup]="CRUDForm" class="ui-g-12 ui-md-6 inputTextForm">
        <span class="p-float-label">
            <input style="width:90%" type="text" pInputText formControlName="behaeltervolumen">
            <label>{{'Behältervolumen'|translate:true}} *</label><!--liter-->
        </span>
    </div>
    <div class="ui-g-12 ui-md-6">
        <div class="errorMessage">
            {{displayMessage.behaeltervolumen}}
        </div>
    </div>

    <div [formGroup]="CRUDForm" class="ui-g-12 ui-md-6 inputTextForm">
        <span class="p-float-label">
            <input style="width:90%" type="text" pInputText formControlName="behaeltergroesse">
            <label>{{'Behältergröße'|translate:true}} *</label><!--kg-->
        </span>
    </div>
    <div class="ui-g-12 ui-md-6">
        <div class="errorMessage">
            {{displayMessage.behaeltergroesse}}
        </div>
    </div>

    <div [formGroup]="CRUDForm" class="ui-g-12 ui-md-6 inputTextForm">
        <span class="p-float-label">
            <input style="width:90%" type="text" pInputText formControlName="tankfarbe">
            <label>{{'Tankfarbe'|translate:true}} *</label>
        </span>
    </div>
    <div class="ui-g-12 ui-md-6">
        <div class="errorMessage">
            {{displayMessage.tankfarbe}}
        </div>
    </div>

    <div [formGroup]="CRUDForm" class="ui-g-12 ui-md-6 inputTextForm">
        <span class="p-float-label">
            <p-calendar [locale]="DE" dateFormat="dd.mm.yy" [showTime]="false" [stepMinute]="01" [showSeconds]="true"
                [defaultDate]="dateNow" [utc]="true" formControlName="faelligkeit" [style]="{'width' : '90%'}"></p-calendar>
            <label>{{'Fälligkeit'|translate:true}}</label>
        </span>
    </div>
    <div class="ui-g-12 ui-md-6">
        <div class="errorMessage">
            {{displayMessage.faelligkeit}}
        </div>
    </div>

    <div [formGroup]="CRUDForm" class="ui-g-12 ui-md-6 inputTextForm">
        <span class="p-float-label">
            <p-calendar [locale]="DE" dateFormat="dd.mm.yy" [showTime]="false" [stepMinute]="01" [showSeconds]="true"
                [defaultDate]="dateNow" [utc]="true" formControlName="letzteAeusserePruefung"
                [style]="{'width' : '90%'}"></p-calendar>
            <label>{{'letzte äußere Prüfung'|translate:true}}</label>
        </span>
    </div>
    <div class="ui-g-12 ui-md-6">
        <div class="errorMessage">
            {{displayMessage.letzteAeusserePruefung}}
        </div>
    </div>

    <div [formGroup]="CRUDForm" class="ui-g-12 ui-md-6 inputTextForm">
        <span class="p-float-label">
            <p-calendar [locale]="DE" dateFormat="dd.mm.yy" [showTime]="false" [stepMinute]="01" [showSeconds]="true"
                [defaultDate]="dateNow" [utc]="true" formControlName="letzteInnerePruefung"
                [style]="{'width' : '90%'}"></p-calendar>
            <label>{{'letzte innere Prüfung'|translate:true}}</label>
        </span>
    </div>
    <div class="ui-g-12 ui-md-6">
        <div class="errorMessage">
            {{displayMessage.letzteInnerePruefung}}
        </div>
    </div>

    <div class="ui-g-12 ui-md-6 inputTextForm"><!--[formGroup]="CRUDForm"-->
        <span class="p-float-label">
            <!--<input style="width:90%" type="text" pInputText formControlName="zustand">-->
            <p-dropdown [options]="zustandOptions" [(ngModel)]="zustandOptionSelected" optionLabel="summary"
                [style]="{'width': '90%', 'height': '36px'}" (onChange)="zustandOptionChanged($event)"></p-dropdown>
            <label>{{'Zustand'|translate:true}} *</label>
        </span>
    </div>
    <div class="ui-g-12 ui-md-6">
        <div class="errorMessage">
            {{displayMessage.zustand}}
        </div>
    </div>

    <div [formGroup]="CRUDForm" class="ui-g-12 ui-md-6 inputTextForm">
        <span class="p-float-label">
            <p-calendar [locale]="DE" dateFormat="dd.mm.yy" [showTime]="false" [stepMinute]="01" [showSeconds]="true"
                [defaultDate]="dateNow" [utc]="true" formControlName="letzteBewegung"
                [style]="{'width' : '90%'}"></p-calendar>
            <label>{{'Letzte Bewegung'|translate:true}}</label>
        </span>
    </div>
    <div class="ui-g-12 ui-md-6">
        <div class="errorMessage">
            {{displayMessage.letzteBewegung}}
        </div>
    </div>

    <div [formGroup]="CRUDForm" class="ui-g-12 ui-md-6 inputTextForm">
        <span class="p-float-label">
            <input style="width:90%" type="text" pInputText formControlName="umbauNummer">
            <label>{{'Umbau Behälter-Nummer'|translate:true}}</label>
        </span>
    </div>
    <div class="ui-g-12 ui-md-6">
        <div class="errorMessage">
            {{displayMessage.umbauNummer}}
        </div>
    </div>
    
    <div [formGroup]="CRUDForm" class="ui-g-12 ui-md-6 inputTextForm">
        <span class="p-float-label">
            <p-calendar [locale]="DE" view="month" dateFormat="dd.mm.yy" [showTime]="false" [stepMinute]="01" [showSeconds]="true"
                [defaultDate]="dateNow" [utc]="true" formControlName="umbauBaujahr" [style]="{'width' : '90%'}"><!--dateFormat="mm/yy"-->
            </p-calendar>
            <label>{{'Umbau Baujahr'|translate:true}}</label>
        </span>
    </div>
    <div class="ui-g-12 ui-md-6">
        <div class="errorMessage">
            {{displayMessage.umbauBaujahr}}
        </div>
    </div>

    <div class="ui-g-12 ui-md-6 inputTextForm"><!--[formGroup]="CRUDForm"-->
        <span class="p-float-label">
            <!--<input style="width:90%" type="text" pInputText formControlName="umbauHersteller">-->
            <p-dropdown [options]="herstellerOptions" [(ngModel)]="umbauHerstellertOptionSelected" optionLabel="summary"
                [style]="{'width': '90%', 'height': '36px'}" (onChange)="umbauHerstellerOptionChanged($event)"></p-dropdown>
            <label>{{'Umbau Hersteller'|translate:true}}</label>
        </span>
    </div>
    <div class="ui-g-12 ui-md-6">
        <div class="errorMessage">
            {{displayMessage.umbauHersteller}}
        </div>
    </div>

    <!--<div [formGroup]="CRUDForm" class="ui-g-12 ui-md-6 inputTextForm">
        <span class="p-float-label">
            <input style="width:90%" type="text" pInputText formControlName="_betriebsdruck">
            <label>{{'TODO: Betriebsdruck max bar'|translate:true}} *</label>
        </span>
    </div>
    <div class="ui-g-12 ui-md-6">
        <div class="errorMessage">
            {{displayMessage.betriebsdruck}}
        </div>
    </div>

    <div [formGroup]="CRUDForm" class="ui-g-12 ui-md-6 inputTextForm">
        <span class="p-float-label">
            <input style="width:90%" type="text" pInputText formControlName="_fuellvolumen2">
            <label>{{'TODO: Füllvolumen max'|translate:true}} *</label>
        </span>
    </div>
    <div class="ui-g-12 ui-md-6">
        <div class="errorMessage">
            {{displayMessage.fuellvolumen}}
        </div>
    </div>-->

    <div class="ui-g-12 ui-md-6 checkboxes"><!--[formGroup]="CRUDForm"-->
        <span class="p-float-label">
            <p-dropdown [options]="verfuegbarkeitOptions" [(ngModel)]="verfuegbarkeitOptionSelected" optionLabel="summary"
                [style]="{'width': '90%', 'height': '36px'}" (onChange)="verfuegbarkeitOptionChanged($event)"></p-dropdown>
            <label>{{'Verfügbarkeit'|translate:true}} *</label>
        </span>
    </div>
    <div class="ui-g-12 ui-md-6">
        <div class="errorMessage">
            {{displayMessage.verfuegbarkeitsstatus}}
        </div>
    </div>

    <div *ngIf="dispositionskennzeichen_bezeichnungen[0] != null" [formGroup]="CRUDForm" class="ui-g-12 ui-md-6 checkboxes">
        <span class="p-float-label">
            <crud-basic-checkbox formControlName="dispokennzeichen_1" [nullable]="false"
                [label]="translate.instant(dispositionskennzeichen_bezeichnungen[0],true)"></crud-basic-checkbox>
        </span>
    </div>
    <div *ngIf="dispositionskennzeichen_bezeichnungen[0] != null" class="ui-g-12 ui-md-6">
        <div class="errorMessage">
            {{displayMessage.dispokennzeichen_1}}
        </div>
    </div>

    <div *ngIf="dispositionskennzeichen_bezeichnungen[1] != null" [formGroup]="CRUDForm" class="ui-g-12 ui-md-6 checkboxes">
        <span class="p-float-label">
            <crud-basic-checkbox formControlName="dispokennzeichen_2" [nullable]="false"
                [label]="translate.instant(dispositionskennzeichen_bezeichnungen[1],true)"></crud-basic-checkbox>
        </span>
    </div>
    <div *ngIf="dispositionskennzeichen_bezeichnungen[1] != null" class="ui-g-12 ui-md-6">
        <div class="errorMessage">
            {{displayMessage.dispokennzeichen_2}}
        </div>
    </div>

    <div *ngIf="dispositionskennzeichen_bezeichnungen[2] != null" [formGroup]="CRUDForm" class="ui-g-12 ui-md-6 checkboxes">
        <span class="p-float-label">
            <crud-basic-checkbox formControlName="dispokennzeichen_3" [nullable]="false"
                [label]="translate.instant(dispositionskennzeichen_bezeichnungen[2],true)"></crud-basic-checkbox>
        </span>
    </div>
    <div *ngIf="dispositionskennzeichen_bezeichnungen[2] != null" class="ui-g-12 ui-md-6">
        <div class="errorMessage">
            {{displayMessage.dispokennzeichen_3}}
        </div>
    </div>

    <div *ngIf="dispositionskennzeichen_bezeichnungen[3] != null" [formGroup]="CRUDForm" class="ui-g-12 ui-md-6 checkboxes">
        <span class="p-float-label">
            <crud-basic-checkbox formControlName="dispokennzeichen_4" [nullable]="false"
                [label]="translate.instant(dispositionskennzeichen_bezeichnungen[3],true)"></crud-basic-checkbox>
        </span>
    </div>
    <div *ngIf="dispositionskennzeichen_bezeichnungen[3] != null" class="ui-g-12 ui-md-6">
        <div class="errorMessage">
            {{displayMessage.dispokennzeichen_4}}
        </div>
    </div>

    <div *ngIf="dispositionskennzeichen_bezeichnungen[4] != null" [formGroup]="CRUDForm" class="ui-g-12 ui-md-6 checkboxes">
        <span class="p-float-label">
            <crud-basic-checkbox formControlName="dispokennzeichen_5" [nullable]="false"
                [label]="translate.instant(dispositionskennzeichen_bezeichnungen[4],true)"></crud-basic-checkbox>
        </span>
    </div>
    <div *ngIf="dispositionskennzeichen_bezeichnungen[4] != null" class="ui-g-12 ui-md-6">
        <div class="errorMessage">
            {{displayMessage.dispokennzeichen_5}}
        </div>
    </div>

    <div *ngIf="dispositionskennzeichen_bezeichnungen[5] != null" [formGroup]="CRUDForm" class="ui-g-12 ui-md-6 checkboxes">
        <span class="p-float-label">
            <crud-basic-checkbox formControlName="dispokennzeichen_1" [nullable]="false"
                [label]="translate.instant(dispositionskennzeichen_bezeichnungen[5],true)"></crud-basic-checkbox>
        </span>
    </div>
    <div *ngIf="dispositionskennzeichen_bezeichnungen[5] != null" class="ui-g-12 ui-md-6">
        <div class="errorMessage">
            {{displayMessage.dispokennzeichen_1}}
        </div>
    </div>

    <div [formGroup]="CRUDForm" class="ui-g-12 ui-md-6 checkboxes">
        <span class="p-float-label">
            <crud-basic-checkbox formControlName="vorhanden" [nullable]="false"
                [label]="translate.instant('vorhanden',true)"></crud-basic-checkbox>
        </span>
    </div>
    <div class="ui-g-12 ui-md-6">
        <div class="errorMessage">
            {{displayMessage.vorhanden}}
        </div>
    </div>

    <!--<div [formGroup]="CRUDForm" class="ui-g-12 ui-md-6 checkboxes">
        <span class="p-float-label">
            <crud-basic-checkbox formControlName="_schrott" [nullable]="false"
                [label]="translate.instant('TODO: Schrott',true)"></crud-basic-checkbox>
        </span>
    </div>
    <div class="ui-g-12 ui-md-6">
        <div class="errorMessage">
            {{displayMessage.schrott}}
        </div>
    </div>-->

    <div [formGroup]="CRUDForm" class="detail-grid-sub inputTextForm">
        <span class="p-float-label">
            <!--<input style="width:100%" type="text" pInputText formControlName="bemerkung">-->
            <textarea #bemerkung style="width: 100%" [rows]="4" pInputTextarea
                formControlName="bemerkung"></textarea><!--kein autoResize="autoResize" sonst optisches Problem beim wieder-reinkommen-->
            <label>{{'Bemerkung'|translate:true}}</label>
        </span>
    </div>
    <div class="detail-grid-sub">
        <div class="errorMessage">
            {{displayMessage.bemerkung}}
        </div>
    </div>

    <div #fileuploadDiv id="fileuploadDiv"><!--die max-height wird noch überschrieben-->
        <!--{{resizeFileUpload() ? null : null}}-->
        <p-fileUpload #inventurFotosFileUpload [files]="inventurFotosFileUpload_files"
            id="dateiHochladen" chooseLabel="Datei auswählen" maxFileSize="999999999" [showUploadButton]="false"
            [showCancelButton]="false" (onSelect)="onNGFileInputSelect($event)"
            (onRemove)="onNGFileInputRemove($event)" multiple="multiple" accept="image/*" maxFileSize="99999999"
            [styleClass]="app.inAppMode == true && app.userAgent == 'DLPApp_Android' ? 'fileUploadStyleHideAuswaehlenButton' : null">
            <ng-template pTemplate="toolbar">
                <div *ngIf="app.inAppMode==true && app.userAgent == 'DLPApp_Android'" style="float:left">
                    <!--im app-Modus: ggf. einen eigenen Button (mit MAUI Event) einblenden - siehe Kommentate bei uploadFromX()-->
                    <button pButton type="button" label="Datei auswählen" icon="fa-solid fa-plus" iconPos="left"
                        (click)="uploadFromX('picker',inventurFotosFileUpload)"></button><!--(click)=""-->
                </div>
                <div style="float:right">
                    <!--<button pButton type="button" label="Kamera" icon="fa-solid fa-camera" iconPos="left"
                        style="margin-right: -0.25em;"
                        (click)="uploadFromX('camera',inventurFotosFileUpload)"></button>--><!--(click)=""-->
                </div>
            </ng-template>
            <ng-template let-file pTemplate="file">
                <div class="ui-fileupload-row ng-star-inserted bilder-grid-container">
                    <div>
                        <img [src]="file._objectURL != undefined ? file._objectURL : file.objectURL" width="75"
                            class="ng-star-inserted">
                    </div>
                    <div>
                        <br><br>
                        {{file._inventurFoto != undefined ? file._inventurFoto.bemerkung : file.name}}
                    </div>
                    <div [style.visibility]="file._percentUploaded == 100 ? 'hidden' : 'unset'">
                        <br><br>
                        {{file._percentUploaded}}%
                    </div>
                    <div>
                        <br>
                        <button pButton *ngIf="file._percentUploaded == 100" type="button"
                            label="{{app.inAppMode ? '' : 'Löschen'}}" icon="fa-solid fa-trash" iconPos="left"
                            style="float:right; margin-right: 0.25em;" [style.width]="app.inAppMode ? '2.5rem' : 'unset'"
                            (click)="inventurBilderDeleteFile(file,'M')"></button>
                        <!--<button pButton type="button" label="Debug" icon="fa-solid fa-debug" iconPos="left" style="float:right; margin-right: 0.25em;" (click)="positionenBilderDebug(file)"></button>-->
                    </div>
                </div>
                <span>
                    <!--<p-progressBar *ngIf="true || file._alreadyUploaded != null && file._alreadyUploaded == false && file._percentUploaded>0" [value]="file._percentUploaded"></p-progressBar>-->
                </span>
            </ng-template>
        </p-fileUpload>
    </div>


<!--
    <div [formGroup]="CRUDForm" class="ui-g-12 ui-md-6 inputTextForm">
        <span class="p-float-label">
            <input style="width:90%" type="text" pInputText formControlName="anlagenart">
            <label>{{'Anlagenart'|translate:true}}</label>
        </span>
    </div>
    <div class="ui-g-12 ui-md-6">
        <div class="errorMessage">
            {{displayMessage.anlagenart}}
        </div>
    </div>

    <div [formGroup]="CRUDForm" class="ui-g-12 ui-md-6 inputTextForm">
        <span class="p-float-label">
            <input style="width:90%" type="text" pInputText formControlName="behaelterId">
            <label>{{'Behälter'|translate:true}}</label>
        </span>
    </div>
    <div class="ui-g-12 ui-md-6">
        <div class="errorMessage">
            {{displayMessage.behaelterId}}
        </div>
    </div>

    <div [formGroup]="CRUDForm" class="ui-g-12 ui-md-6 inputTextForm">
        <span class="p-float-label">
            <input style="width:90%" type="text" pInputText formControlName="bemerkung">
            <label>{{'Bemerkung'|translate:true}}</label>
        </span>
    </div>
    <div class="ui-g-12 ui-md-6">
        <div class="errorMessage">
            {{displayMessage.bemerkung}}
        </div>
    </div>

    <div [formGroup]="CRUDForm" class="ui-g-12 ui-md-6 inputTextForm">
        <span class="p-float-label">
            <input style="width:90%" type="text" pInputText formControlName="dienstleisterId">
            <label>{{'Dienstleister'|translate:true}} *</label>
        </span>
    </div>
    <div class="ui-g-12 ui-md-6">
        <div class="errorMessage">
            {{displayMessage.dienstleisterId}}
        </div>
    </div>


    <div [formGroup]="CRUDForm" class="ui-g-12 ui-md-6 inputTextForm">
        <span class="p-float-label">
            <input style="width:90%" type="text" pInputText formControlName="interneBehaelterNummer">
            <label>{{'Interne Behälter-Nummer'|translate:true}}</label>
        </span>
    </div>
    <div class="ui-g-12 ui-md-6">
        <div class="errorMessage">
            {{displayMessage.interneBehaelterNummer}}
        </div>
    </div>

    <div [formGroup]="CRUDForm" class="ui-g-12 ui-md-6 inputTextForm">
        <span class="p-float-label">
            <p-calendar [locale]="DE" dateFormat="dd.mm.yy" [showTime]="false" [stepMinute]="01" [showSeconds]="true"
                [defaultDate]="dateNow" [utc]="true" formControlName="inventurdatum"
                [style]="{'width' : '90%'}"></p-calendar>
            <label>{{'Inventurdatum'|translate:true}} *</label>
        </span>
    </div>
    <div class="ui-g-12 ui-md-6">
        <div class="errorMessage">
            {{displayMessage.inventurdatum}}
        </div>
    </div>




    <div [formGroup]="CRUDForm" class="ui-g-12 ui-md-6 inputTextForm">
        <span class="p-float-label">
            <p-calendar [locale]="DE" dateFormat="dd.mm.yy" [showTime]="false" [stepMinute]="01" [showSeconds]="true"
                [defaultDate]="dateNow" [utc]="true" formControlName="rueckgemeldet"
                [style]="{'width' : '90%'}"></p-calendar>
            <label>{{'Rückmelde-Datum'|translate:true}}</label>
        </span>
    </div>
    <div class="ui-g-12 ui-md-6">
        <div class="errorMessage">
            {{displayMessage.rueckgemeldet}}
        </div>
    </div>



    <div [formGroup]="CRUDForm" class="ui-g-12 ui-md-6 inputTextForm">
        <span class="p-float-label">
            <p-calendar [locale]="DE" dateFormat="dd.mm.yy" [showTime]="false" [stepMinute]="01" [showSeconds]="true"
                [defaultDate]="dateNow" [utc]="true" formControlName="tUEVDatum"
                [style]="{'width' : '90%'}"></p-calendar>
            <label>{{'TÜV-Datum'|translate:true}}</label>
        </span>
    </div>
    <div class="ui-g-12 ui-md-6">
        <div class="errorMessage">
            {{displayMessage.tUEVDatum}}
        </div>
    </div>

    <div [formGroup]="CRUDForm" class="ui-g-12 ui-md-6 inputTextForm">
        <span class="p-float-label">
            <input style="width:90%" type="text" pInputText formControlName="verfuegbarkeitsstatus">
            <label>{{'Verfügbarkeitsstatus'|translate:true}} *</label>
        </span>
    </div>
    <div class="ui-g-12 ui-md-6">
        <div class="errorMessage">
            {{displayMessage.verfuegbarkeitsstatus}}
        </div>
    </div>

    <div [formGroup]="CRUDForm" class="ui-g-12 ui-md-6 checkboxes">
        <span class="p-float-label">
            <crud-basic-checkbox formControlName="armaturenMittig" [nullable]="false"
                [label]="translate.instant('Armaturen Mittig',true)"></crud-basic-checkbox>
        </span>
    </div>
    <div class="ui-g-12 ui-md-6">
        <div class="errorMessage">
            {{displayMessage.armaturenMittig}}
        </div>
    </div>

    <div [formGroup]="CRUDForm" class="ui-g-12 ui-md-6 checkboxes">
        <span class="p-float-label">
            <crud-basic-checkbox formControlName="armaturenverlaengerungImDomschacht" [nullable]="false"
                [label]="translate.instant('Armaturenverlängerung im Domschacht',true)"></crud-basic-checkbox>
        </span>
    </div>
    <div class="ui-g-12 ui-md-6">
        <div class="errorMessage">
            {{displayMessage.armaturenverlaengerungImDomschacht}}
        </div>
    </div>

    <div [formGroup]="CRUDForm" class="ui-g-12 ui-md-6 checkboxes">
        <span class="p-float-label">
            <crud-basic-checkbox formControlName="fluessigentnahmeFlansch" [nullable]="false"
                [label]="translate.instant('Flüssigentnahme-Flansch',true)"></crud-basic-checkbox>
        </span>
    </div>
    <div class="ui-g-12 ui-md-6">
        <div class="errorMessage">
            {{displayMessage.fluessigentnahmeFlansch}}
        </div>
    </div>


    <div [formGroup]="CRUDForm" class="ui-g-12 ui-md-6 checkboxes">
        <span class="p-float-label">
            <crud-basic-checkbox formControlName="mitASS" [nullable]="false"
                [label]="translate.instant('mit ASS',true)"></crud-basic-checkbox>
        </span>
    </div>
    <div class="ui-g-12 ui-md-6">
        <div class="errorMessage">
            {{displayMessage.mitASS}}
        </div>
    </div>
-->




</div><!--detail-grid"-->
</ng-template>